import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/core/common-services/user.services';
import { UserDataService } from 'src/app/core/data-services/identity/user.data.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { NotificationDataService } from 'src/app/core/data-services/notification/notification-data.service';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { InvestingType } from 'src/app/core/data-models/kyc.data.models';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';


@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy{
  companyName: string = '';
  @ViewChild('logoutTemplateRef') logoutTemplateRef!: TemplateRef<any>;
  public isMobileView = false;
  breakPoinSubscription!:Subscription;
  investTypes=InvestingType;
  logoUrl:string='';
  constructor(
    private userDataService : UserDataService,
    protected userService: UserService,
    private matDialog:MatDialog,
    public languageService:LanguageService,
    private responsive: BreakpointObserver,
    private notificationDataService:NotificationDataService,
    public notificationService:NotificationService,
    private tenantConfigService: TenantConfigService,
  ){
    this.companyName = localStorage.getItem('currentLang') === 'ar' && this.tenantConfigService.tenant.companyNameAr ? this.tenantConfigService.tenant.companyNameAr : this.tenantConfigService.tenant.companyName;
    this.logoUrl=this.tenantConfigService.tenant.coloredLogoUrl;
  }
  ngOnDestroy(): void {
    this.breakPoinSubscription.unsubscribe();
  }

  ngOnInit(): void {
   this.breakPoinSubscription= this.responsive.observe([
    Breakpoints.Small,
    Breakpoints.Handset,
    Breakpoints.Tablet,
    Breakpoints.HandsetPortrait,
    Breakpoints.HandsetLandscape,
    Breakpoints.TabletPortrait,
    Breakpoints.TabletLandscape,    
      ])
      .subscribe(result => {

        this.isMobileView = false; 

        if (result.matches) {
          this.isMobileView = true;
        }
        console.log('isMobileView:'+this.isMobileView)

  });
  this.getPushNotificationsCount();
  }
getPushNotificationsCount(){
  this.notificationDataService.GetUnreadNotificationsCount().subscribe({
    next:(res)=>{
      if(res&&res.data){
        this.notificationService.unreadPushNotificationsCount=res.data.unreadNotificationsCount;
      }
    }
  })
}
  logOut() {
    this.closeLogoutDialog();
    return this.userDataService.Logout().subscribe({
      next: () => {
        this.userService.logout();
      },
      error: (err) => {
        console.error('Error occurred during logout:', err);
        this.userService.logout(); // Call in error case as well
      }
    });
  }
  closeLogoutDialog(){
    this.matDialog.closeAll();
  }
  openLogoutDialog(){
    this.closeLogoutDialog();
    this.matDialog.open(this.logoutTemplateRef, {     
      height: 'auto',
      width:'600px',
      panelClass:'dialog-class',
    });
  }
}
